// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ======================
   Create Video Page

   Design System: Uses CSS variables from colors.css
   ====================== */

.create-video-content {
  position: relative;
  max-width: 1180px;
  margin: 0 auto;
  padding: 36px 32px 80px;
  min-height: 100%;
  width: 100%;
  box-sizing: border-box;
  color: var(--color-text-primary);
  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;
  background: var(--color-bg-root);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.create-video-back {
  position: static;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  align-self: flex-start;
  width: fit-content;
  padding: 7px 10px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: color-mix(in srgb, var(--color-bg-canvas-surface) 72%, transparent);
  color: var(--color-text-secondary);
  font-size: 12.5px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: color 0.15s ease;
  margin: 0 0 72px -10px;
}

.create-video-back:hover {
  color: var(--color-text-primary);
  border-color: var(--color-border-input);
}

.create-video-panel {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.create-video-heading {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
  text-align: left;
  margin-bottom: 12px;
}

.create-video-title {
  margin: 0;
  font-size: 40px;
  font-weight: 500;
  line-height: 1.15;
  font-family: 'Geist Sans', 'Times New Roman', serif;
}

.create-video-subtitle {
  margin: 0;
  font-size: 14px;
  color: var(--color-text-secondary);
}

/* Composer */

.create-video-composer {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 20px 20px 16px;
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  background: var(--color-bg-canvas-surface);
  box-shadow: none;
  transition: border-color 0.15s ease;
}

.create-video-composer:focus-within {
  border-color: var(--color-text-secondary);
}

.create-video-textarea {
  width: 100%;
  box-sizing: border-box;
  padding: 0 4px 8px;
  border: none;
  background: transparent;
  font-size: 14px;
  line-height: 1.55;
  color: var(--color-text-primary);
  font-family: inherit;
  resize: none;
  min-height: 320px;
}

.create-video-textarea:focus {
  outline: none;
}

.create-video-textarea::placeholder {
  color: var(--color-text-secondary);
}

/* Model input slots (start frame / end frame / reference images) */

.create-video-inputs {
  display: flex;
  align-items: stretch;
  gap: 8px;
  flex-wrap: wrap;
}

.create-video-tile {
  position: relative;
  width: 96px;
  height: 64px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  flex-shrink: 0;
  box-sizing: border-box;
}

.create-video-tile img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.create-video-tile-label {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 12px 6px 4px;
  font-size: 9.5px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #fff;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.72), rgba(0, 0, 0, 0));
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.create-video-tile-remove {
  position: absolute;
  top: 4px;
  right: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border: none;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  cursor: pointer;
  transition: background 0.15s ease;
}

.create-video-tile-remove:hover:not(:disabled) {
  background: rgba(0, 0, 0, 0.8);
}

.create-video-tile--add {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 0 6px;
  border: 1px dashed var(--color-border-input);
  background: transparent;
  color: var(--color-text-secondary);
  font-size: 10px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;
}

.create-video-tile--add span {
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.create-video-tile--add:hover:not(:disabled) {
  border-color: var(--color-text-secondary);
  color: var(--color-text-primary);
  background: var(--color-bg-user-bubble);
}

.create-video-tile--add:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.create-video-tile-required {
  color: var(--color-status-error-text);
  font-style: normal;
  margin-left: 1px;
}

.create-video-inputs-hint {
  margin: -4px 0 0;
  font-size: 11.5px;
  color: var(--color-text-secondary);
}

/* Controls */

.create-video-controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
  border-top: 1px solid var(--color-border-input);
  padding-top: 16px;
}

.create-video-controls-left {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.create-video-controls-right {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.create-video-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 10px;
  border: 1px solid var(--color-border-input);
  border-radius: 8px;
  background: transparent;
  color: var(--color-text-secondary);
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
  white-space: nowrap;
}

.create-video-chip:hover:not(:disabled) {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

.create-video-chip:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.create-video-chip--active {
  color: var(--color-text-primary);
  border-color: var(--color-text-secondary);
}

/* Aspect ratio segmented control */

.create-video-aspect-group {
  display: flex;
  gap: 2px;
  padding: 2px;
  background: var(--color-bg-input);
  border: 1px solid var(--color-border-input);
  border-radius: 8px;
}

.create-video-aspect {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 9px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: var(--color-text-secondary);
  font-size: 11.5px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
  white-space: nowrap;
}

.create-video-aspect-glyph {
  display: inline-block;
  flex: 0 0 auto;
  box-sizing: border-box;
  border: 1.5px solid currentColor;
  border-radius: 2px;
  opacity: 0.82;
}

.create-video-aspect:hover:not(.create-video-aspect--active):not(:disabled) {
  color: var(--color-text-primary);
}

.create-video-aspect--active {
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-primary);
}

/* Model selector */

.create-video-model-trigger {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-width: 0;
  padding: 7px 10px;
  border: 1px solid var(--color-border-input);
  border-radius: 8px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: border-color 0.15s ease;
}

.create-video-model-trigger:hover:not(:disabled) {
  border-color: var(--color-text-secondary);
}

.create-video-model-thumb {
  width: 16px;
  height: 16px;
  border-radius: 3px;
  object-fit: contain;
  flex-shrink: 0;
}

.create-video-model-label {
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Dropdown menus */

.create-video-menu {
  z-index: 2100;
  min-width: 150px;
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  padding: 4px;
  box-shadow: 0 12px 32px -16px rgba(0, 0, 0, 0.45);
}

.create-video-menu--models {
  min-width: 240px;
  max-height: 320px;
  overflow-y: auto;
}

.create-video-menu--duration {
  max-height: min(320px, var(--radix-dropdown-menu-content-available-height));
  overflow-y: auto;
}

.create-video-menu-item {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 8px 10px;
  border-radius: 4px;
  font-size: 12.5px;
  font-weight: 500;
  color: var(--color-text-primary);
  cursor: pointer;
  outline: none;
  transition: background 0.12s ease;
}

.create-video-menu-item:hover,
.create-video-menu-item:focus {
  background: var(--color-bg-user-bubble);
}

.create-video-menu-item--disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.create-video-menu-item-copy {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
  flex: 1 1;
}

.create-video-menu-item-label {
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.create-video-menu-item-desc {
  font-size: 10.5px;
  font-weight: 500;
  color: var(--color-text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.create-video-menu-check {
  color: var(--color-text-primary);
  flex-shrink: 0;
  margin-left: auto;
}

.create-video-menu-empty {
  padding: 12px;
  font-size: 12px;
  color: var(--color-text-secondary);
  text-align: center;
}

/* Error */

.create-video-error {
  padding: 10px 14px;
  border-radius: 6px;
  background: var(--color-status-error-tint);
  border: 1px solid var(--color-status-error-border);
  color: var(--color-status-error-text);
  font-size: 13px;
  font-weight: 500;
}

.create-video-submit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 34px;
  padding: 0 12px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  box-shadow: none;
  transition: background 0.15s ease;
}

.create-video-submit:hover:not(:disabled) {
  background: var(--color-bg-user-bubble);
}

.create-video-submit:disabled {
  border-color: var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-text-secondary);
  box-shadow: none;
  opacity: 0.4;
  cursor: not-allowed;
}

.create-video-submit-spinner {
  animation: create-video-spin 1s linear infinite;
}

@keyframes create-video-spin {
  to {
    transform: rotate(360deg);
  }
}

.create-video-footnote {
  margin: 0;
  text-align: center;
  font-size: 11px;
  line-height: 1.5;
  color: var(--color-text-secondary);
}

/* Stable two-column workspace: model-specific options never resize the prompt. */
.create-video-workspace {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 340px;
  gap: 18px;
  align-items: start;
}

.create-video-main {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.create-video-field-label,
.create-video-setting-heading {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.01em;
  color: var(--color-text-primary);
}

.create-video-prompt-meta {
  align-self: flex-end;
  margin-top: auto;
  font-size: 10px;
  color: var(--color-text-secondary);
}

.create-video-settings {
  display: flex;
  flex-direction: column;
  gap: 0;
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  background: var(--color-bg-canvas-surface);
  overflow: hidden;
}

.create-video-setting-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px;
  border-bottom: 1px solid var(--color-border-input);
}

.create-video-setting-section--row {
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.create-video-setting-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.create-video-setting-heading > span:last-child:not(:first-child) {
  color: var(--color-text-secondary);
  font-size: 10px;
  font-weight: 500;
}

.create-video-settings .create-video-model-trigger {
  width: 100%;
  min-height: 54px;
  padding: 9px 10px;
  border-radius: 5px;
  background: var(--color-bg-input);
  text-align: left;
}

.create-video-model-trigger-copy {
  display: flex;
  flex: 1 1;
  min-width: 0;
  flex-direction: column;
  gap: 2px;
}

.create-video-model-label,
.create-video-model-summary {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.create-video-model-label {
  max-width: none;
  font-size: 12px;
  color: var(--color-text-primary);
}

.create-video-model-summary {
  font-size: 10px;
  color: var(--color-text-secondary);
}

.create-video-inputs {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.create-video-tile {
  width: 100%;
  height: 62px;
}

.create-video-aspect-group {
  display: grid;
  grid-template-columns: repeat(var(--create-video-aspect-columns, 3), minmax(0, 1fr));
  gap: 3px;
  padding: 3px;
}

.create-video-aspect {
  justify-content: center;
  min-width: 0;
  padding: 7px 4px;
  font-size: 10.5px;
}

.create-video-settings .create-video-chip {
  min-width: 72px;
  justify-content: space-between;
}

.create-video-select {
  min-width: 92px;
  height: 34px;
  padding: 0 28px 0 10px;
  border: 1px solid var(--color-border-input);
  border-radius: 5px;
  outline: none;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font: inherit;
  font-size: 12px;
  cursor: pointer;
}

.create-video-select:focus {
  border-color: var(--color-text-secondary);
}

.create-video-cost-estimate {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px 0;
  font-size: 11px;
  color: var(--color-text-primary);
}

.create-video-cost-estimate > span:last-child {
  color: var(--color-text-secondary);
  font-size: 9.5px;
  white-space: nowrap;
}

.create-video-settings .create-video-submit {
  width: auto;
  height: 42px;
  margin: 14px;
}

.create-video-menu--models {
  width: 380px;
  max-width: calc(100vw - 32px);
  max-height: min(520px, calc(100vh - 96px));
  padding: 0;
  overflow: hidden;
  border-radius: 8px;
}

.create-video-model-search-wrap {
  display: flex;
  flex-direction: column;
  gap: 7px;
  padding: 12px;
  border-bottom: 1px solid var(--color-border-input);
}

.create-video-model-search-wrap > span {
  font-size: 10px;
  color: var(--color-text-secondary);
}

.create-video-model-search {
  width: 100%;
  box-sizing: border-box;
  height: 36px;
  padding: 0 10px;
  border: 1px solid var(--color-border-input);
  border-radius: 5px;
  outline: none;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font: inherit;
  font-size: 12px;
}

.create-video-model-search:focus {
  border-color: var(--color-text-secondary);
}

.create-video-model-list {
  max-height: 430px;
  padding: 5px;
  overflow-y: auto;
}

.create-video-menu-item--model {
  min-height: 48px;
  padding: 8px 9px;
  border: 1px solid transparent;
  border-radius: 6px;
}

.create-video-menu-item--selected {
  border-color: var(--color-border-input);
  background: var(--color-bg-user-bubble);
}

.create-video-model-thumb--large,
.create-video-model-thumb--placeholder {
  width: 28px;
  height: 28px;
  border-radius: 6px;
}

.create-video-toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--color-text-secondary);
  font-size: 13px;
  cursor: pointer;
}

.create-video-toggle input {
  width: 15px;
  height: 15px;
  accent-color: var(--color-text-primary);
}

.create-video-model-thumb--placeholder {
  display: block;
  background: var(--color-bg-input);
  border: 1px solid var(--color-border-input);
}

@media (max-width: 900px) {
  .create-video-content {
    padding: 24px 18px 48px;
  }

  .create-video-back {
    margin-bottom: 42px;
  }

  .create-video-title {
    font-size: 36px;
  }

  .create-video-composer {
    padding: 16px;
  }

  .create-video-workspace {
    grid-template-columns: 1fr;
  }

  .create-video-textarea {
    min-height: 210px;
  }

  .create-video-controls {
    align-items: stretch;
    flex-direction: column;
  }

  .create-video-controls-right,
  .create-video-model-trigger {
    width: 100%;
  }

  .create-video-model-trigger {
    justify-content: center;
  }

  .create-video-footnote {
    line-height: 1.5;
  }
}
`, "",{"version":3,"sources":["webpack://./src/CreateVideoPage.css"],"names":[],"mappings":"AAAA;;;;2BAI2B;;AAE3B;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,gCAAgC;EAChC,8EAA8E;EAC9E,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,+EAA+E;EAC/E,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mDAAmD;AACrD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kCAAkC;AACpC;;AAEA,aAAa;;AAEb;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,2CAA2C;EAC3C,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,gCAAgC;EAChC,oBAAoB;EACpB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kCAAkC;AACpC;;AAEA,mEAAmE;;AAEnE;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,iCAAiC;EACjC,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,0EAA0E;EAC1E,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,4CAA4C;EAC5C,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yCAAyC;EACzC,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA,aAAa;;AAEb;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,+CAA+C;EAC/C,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mDAAmD;EACnD,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA,mCAAmC;;AAEnC;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,iCAAiC;EACjC,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mDAAmD;EACnD,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,sBAAsB;EACtB,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA,mBAAmB;;AAEnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,mBAAmB;;AAEnB;EACE,aAAa;EACb,gBAAgB;EAChB,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;EAClB,YAAY;EACZ,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,2EAA2E;EAC3E,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,iCAAiC;AACnC;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA,UAAU;;AAEV;EACE,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;EAC1C,kDAAkD;EAClD,qCAAqC;EACrC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;EACvC,iCAAiC;EACjC,kCAAkC;EAClC,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA,iFAAiF;AACjF;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,2CAA2C;EAC3C,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,oFAAoF;EACpF,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,iCAAiC;EACjC,gCAAgC;EAChC,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,0CAA0C;EAC1C,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,kDAAkD;AACpD;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,iCAAiC;EACjC,gCAAgC;EAChC,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kCAAkC;EAClC,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* ======================\n   Create Video Page\n\n   Design System: Uses CSS variables from colors.css\n   ====================== */\n\n.create-video-content {\n  position: relative;\n  max-width: 1180px;\n  margin: 0 auto;\n  padding: 36px 32px 80px;\n  min-height: 100%;\n  width: 100%;\n  box-sizing: border-box;\n  color: var(--color-text-primary);\n  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;\n  background: var(--color-bg-root);\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n}\n\n.create-video-back {\n  position: static;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  align-self: flex-start;\n  width: fit-content;\n  padding: 7px 10px;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  background: color-mix(in srgb, var(--color-bg-canvas-surface) 72%, transparent);\n  color: var(--color-text-secondary);\n  font-size: 12.5px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  transition: color 0.15s ease;\n  margin: 0 0 72px -10px;\n}\n\n.create-video-back:hover {\n  color: var(--color-text-primary);\n  border-color: var(--color-border-input);\n}\n\n.create-video-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.create-video-heading {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  align-items: flex-start;\n  text-align: left;\n  margin-bottom: 12px;\n}\n\n.create-video-title {\n  margin: 0;\n  font-size: 40px;\n  font-weight: 500;\n  line-height: 1.15;\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n}\n\n.create-video-subtitle {\n  margin: 0;\n  font-size: 14px;\n  color: var(--color-text-secondary);\n}\n\n/* Composer */\n\n.create-video-composer {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 20px 20px 16px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  background: var(--color-bg-canvas-surface);\n  box-shadow: none;\n  transition: border-color 0.15s ease;\n}\n\n.create-video-composer:focus-within {\n  border-color: var(--color-text-secondary);\n}\n\n.create-video-textarea {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0 4px 8px;\n  border: none;\n  background: transparent;\n  font-size: 14px;\n  line-height: 1.55;\n  color: var(--color-text-primary);\n  font-family: inherit;\n  resize: none;\n  min-height: 320px;\n}\n\n.create-video-textarea:focus {\n  outline: none;\n}\n\n.create-video-textarea::placeholder {\n  color: var(--color-text-secondary);\n}\n\n/* Model input slots (start frame / end frame / reference images) */\n\n.create-video-inputs {\n  display: flex;\n  align-items: stretch;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.create-video-tile {\n  position: relative;\n  width: 96px;\n  height: 64px;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  flex-shrink: 0;\n  box-sizing: border-box;\n}\n\n.create-video-tile img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.create-video-tile-label {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  padding: 12px 6px 4px;\n  font-size: 9.5px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #fff;\n  background: linear-gradient(to top, rgba(0, 0, 0, 0.72), rgba(0, 0, 0, 0));\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.create-video-tile-remove {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border: none;\n  border-radius: 5px;\n  background: rgba(0, 0, 0, 0.55);\n  color: #fff;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.create-video-tile-remove:hover:not(:disabled) {\n  background: rgba(0, 0, 0, 0.8);\n}\n\n.create-video-tile--add {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  padding: 0 6px;\n  border: 1px dashed var(--color-border-input);\n  background: transparent;\n  color: var(--color-text-secondary);\n  font-size: 10px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;\n}\n\n.create-video-tile--add span {\n  max-width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.create-video-tile--add:hover:not(:disabled) {\n  border-color: var(--color-text-secondary);\n  color: var(--color-text-primary);\n  background: var(--color-bg-user-bubble);\n}\n\n.create-video-tile--add:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.create-video-tile-required {\n  color: var(--color-status-error-text);\n  font-style: normal;\n  margin-left: 1px;\n}\n\n.create-video-inputs-hint {\n  margin: -4px 0 0;\n  font-size: 11.5px;\n  color: var(--color-text-secondary);\n}\n\n/* Controls */\n\n.create-video-controls {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  flex-wrap: wrap;\n  border-top: 1px solid var(--color-border-input);\n  padding-top: 16px;\n}\n\n.create-video-controls-left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.create-video-controls-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.create-video-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 10px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 8px;\n  background: transparent;\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n  white-space: nowrap;\n}\n\n.create-video-chip:hover:not(:disabled) {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n.create-video-chip:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.create-video-chip--active {\n  color: var(--color-text-primary);\n  border-color: var(--color-text-secondary);\n}\n\n/* Aspect ratio segmented control */\n\n.create-video-aspect-group {\n  display: flex;\n  gap: 2px;\n  padding: 2px;\n  background: var(--color-bg-input);\n  border: 1px solid var(--color-border-input);\n  border-radius: 8px;\n}\n\n.create-video-aspect {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 5px 9px;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  color: var(--color-text-secondary);\n  font-size: 11.5px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n  white-space: nowrap;\n}\n\n.create-video-aspect-glyph {\n  display: inline-block;\n  flex: 0 0 auto;\n  box-sizing: border-box;\n  border: 1.5px solid currentColor;\n  border-radius: 2px;\n  opacity: 0.82;\n}\n\n.create-video-aspect:hover:not(.create-video-aspect--active):not(:disabled) {\n  color: var(--color-text-primary);\n}\n\n.create-video-aspect--active {\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-primary);\n}\n\n/* Model selector */\n\n.create-video-model-trigger {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  min-width: 0;\n  padding: 7px 10px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 8px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-size: 12px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  transition: border-color 0.15s ease;\n}\n\n.create-video-model-trigger:hover:not(:disabled) {\n  border-color: var(--color-text-secondary);\n}\n\n.create-video-model-thumb {\n  width: 16px;\n  height: 16px;\n  border-radius: 3px;\n  object-fit: contain;\n  flex-shrink: 0;\n}\n\n.create-video-model-label {\n  max-width: 180px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Dropdown menus */\n\n.create-video-menu {\n  z-index: 2100;\n  min-width: 150px;\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  padding: 4px;\n  box-shadow: 0 12px 32px -16px rgba(0, 0, 0, 0.45);\n}\n\n.create-video-menu--models {\n  min-width: 240px;\n  max-height: 320px;\n  overflow-y: auto;\n}\n\n.create-video-menu--duration {\n  max-height: min(320px, var(--radix-dropdown-menu-content-available-height));\n  overflow-y: auto;\n}\n\n.create-video-menu-item {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  padding: 8px 10px;\n  border-radius: 4px;\n  font-size: 12.5px;\n  font-weight: 500;\n  color: var(--color-text-primary);\n  cursor: pointer;\n  outline: none;\n  transition: background 0.12s ease;\n}\n\n.create-video-menu-item:hover,\n.create-video-menu-item:focus {\n  background: var(--color-bg-user-bubble);\n}\n\n.create-video-menu-item--disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.create-video-menu-item-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  min-width: 0;\n  flex: 1;\n}\n\n.create-video-menu-item-label {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.create-video-menu-item-desc {\n  font-size: 10.5px;\n  font-weight: 500;\n  color: var(--color-text-secondary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.create-video-menu-check {\n  color: var(--color-text-primary);\n  flex-shrink: 0;\n  margin-left: auto;\n}\n\n.create-video-menu-empty {\n  padding: 12px;\n  font-size: 12px;\n  color: var(--color-text-secondary);\n  text-align: center;\n}\n\n/* Error */\n\n.create-video-error {\n  padding: 10px 14px;\n  border-radius: 6px;\n  background: var(--color-status-error-tint);\n  border: 1px solid var(--color-status-error-border);\n  color: var(--color-status-error-text);\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.create-video-submit {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 34px;\n  padding: 0 12px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-size: 12px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  box-shadow: none;\n  transition: background 0.15s ease;\n}\n\n.create-video-submit:hover:not(:disabled) {\n  background: var(--color-bg-user-bubble);\n}\n\n.create-video-submit:disabled {\n  border-color: var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-text-secondary);\n  box-shadow: none;\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.create-video-submit-spinner {\n  animation: create-video-spin 1s linear infinite;\n}\n\n@keyframes create-video-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.create-video-footnote {\n  margin: 0;\n  text-align: center;\n  font-size: 11px;\n  line-height: 1.5;\n  color: var(--color-text-secondary);\n}\n\n/* Stable two-column workspace: model-specific options never resize the prompt. */\n.create-video-workspace {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 340px;\n  gap: 18px;\n  align-items: start;\n}\n\n.create-video-main {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.create-video-field-label,\n.create-video-setting-heading {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  color: var(--color-text-primary);\n}\n\n.create-video-prompt-meta {\n  align-self: flex-end;\n  margin-top: auto;\n  font-size: 10px;\n  color: var(--color-text-secondary);\n}\n\n.create-video-settings {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  background: var(--color-bg-canvas-surface);\n  overflow: hidden;\n}\n\n.create-video-setting-section {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 14px;\n  border-bottom: 1px solid var(--color-border-input);\n}\n\n.create-video-setting-section--row {\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.create-video-setting-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.create-video-setting-heading > span:last-child:not(:first-child) {\n  color: var(--color-text-secondary);\n  font-size: 10px;\n  font-weight: 500;\n}\n\n.create-video-settings .create-video-model-trigger {\n  width: 100%;\n  min-height: 54px;\n  padding: 9px 10px;\n  border-radius: 5px;\n  background: var(--color-bg-input);\n  text-align: left;\n}\n\n.create-video-model-trigger-copy {\n  display: flex;\n  flex: 1;\n  min-width: 0;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.create-video-model-label,\n.create-video-model-summary {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.create-video-model-label {\n  max-width: none;\n  font-size: 12px;\n  color: var(--color-text-primary);\n}\n\n.create-video-model-summary {\n  font-size: 10px;\n  color: var(--color-text-secondary);\n}\n\n.create-video-inputs {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.create-video-tile {\n  width: 100%;\n  height: 62px;\n}\n\n.create-video-aspect-group {\n  display: grid;\n  grid-template-columns: repeat(var(--create-video-aspect-columns, 3), minmax(0, 1fr));\n  gap: 3px;\n  padding: 3px;\n}\n\n.create-video-aspect {\n  justify-content: center;\n  min-width: 0;\n  padding: 7px 4px;\n  font-size: 10.5px;\n}\n\n.create-video-settings .create-video-chip {\n  min-width: 72px;\n  justify-content: space-between;\n}\n\n.create-video-select {\n  min-width: 92px;\n  height: 34px;\n  padding: 0 28px 0 10px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 5px;\n  outline: none;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font: inherit;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.create-video-select:focus {\n  border-color: var(--color-text-secondary);\n}\n\n.create-video-cost-estimate {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 14px 0;\n  font-size: 11px;\n  color: var(--color-text-primary);\n}\n\n.create-video-cost-estimate > span:last-child {\n  color: var(--color-text-secondary);\n  font-size: 9.5px;\n  white-space: nowrap;\n}\n\n.create-video-settings .create-video-submit {\n  width: auto;\n  height: 42px;\n  margin: 14px;\n}\n\n.create-video-menu--models {\n  width: 380px;\n  max-width: calc(100vw - 32px);\n  max-height: min(520px, calc(100vh - 96px));\n  padding: 0;\n  overflow: hidden;\n  border-radius: 8px;\n}\n\n.create-video-model-search-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n  padding: 12px;\n  border-bottom: 1px solid var(--color-border-input);\n}\n\n.create-video-model-search-wrap > span {\n  font-size: 10px;\n  color: var(--color-text-secondary);\n}\n\n.create-video-model-search {\n  width: 100%;\n  box-sizing: border-box;\n  height: 36px;\n  padding: 0 10px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 5px;\n  outline: none;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font: inherit;\n  font-size: 12px;\n}\n\n.create-video-model-search:focus {\n  border-color: var(--color-text-secondary);\n}\n\n.create-video-model-list {\n  max-height: 430px;\n  padding: 5px;\n  overflow-y: auto;\n}\n\n.create-video-menu-item--model {\n  min-height: 48px;\n  padding: 8px 9px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n}\n\n.create-video-menu-item--selected {\n  border-color: var(--color-border-input);\n  background: var(--color-bg-user-bubble);\n}\n\n.create-video-model-thumb--large,\n.create-video-model-thumb--placeholder {\n  width: 28px;\n  height: 28px;\n  border-radius: 6px;\n}\n\n.create-video-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--color-text-secondary);\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.create-video-toggle input {\n  width: 15px;\n  height: 15px;\n  accent-color: var(--color-text-primary);\n}\n\n.create-video-model-thumb--placeholder {\n  display: block;\n  background: var(--color-bg-input);\n  border: 1px solid var(--color-border-input);\n}\n\n@media (max-width: 900px) {\n  .create-video-content {\n    padding: 24px 18px 48px;\n  }\n\n  .create-video-back {\n    margin-bottom: 42px;\n  }\n\n  .create-video-title {\n    font-size: 36px;\n  }\n\n  .create-video-composer {\n    padding: 16px;\n  }\n\n  .create-video-workspace {\n    grid-template-columns: 1fr;\n  }\n\n  .create-video-textarea {\n    min-height: 210px;\n  }\n\n  .create-video-controls {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .create-video-controls-right,\n  .create-video-model-trigger {\n    width: 100%;\n  }\n\n  .create-video-model-trigger {\n    justify-content: center;\n  }\n\n  .create-video-footnote {\n    line-height: 1.5;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
